module.exports = __webpack_public_path__ + "static/img/menu-product_ant@2x.981ec28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-product_ant@2x.png
// module id = 58
// module chunks = 0